import * as React from 'react';
import FieldsLabel from './FieldsLabel';
import { twMerge } from 'tailwind-merge';
import { formClasses } from './TextInput';

export interface MultiLineTextInputProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string;
  label?: string;
  type?: React.HTMLInputTypeAttribute;
  isValid?: boolean;
  isInvalid?: boolean;
  className?: string;
}

export function MultiLineTextInput({
  id,
  label,
  type = 'text',
  isValid,
  isInvalid,
  className,
  ...props
}: MultiLineTextInputProps) {
  return (
    <div className={className}>
      {label && <FieldsLabel id={id}>{label}</FieldsLabel>}
      <textarea
        id={id}
        rows={5}
        {...props}
        className={twMerge(
          formClasses,
          isValid && 'border-success focus:border-success focus:ring-success',
          isInvalid && 'border-error focus:border-error focus:ring-error',
        )}
      />
    </div>
  );
}
